/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { DocumentDraftsControllerMessageMutationRequest, DocumentDraftsControllerMessageMutationResponse, DocumentDraftsControllerMessagePathParams, DocumentDraftsControllerMessage400, DocumentDraftsControllerMessage401, DocumentDraftsControllerMessage403 } from "../../models/documentDraftsController/DocumentDraftsControllerMessage";

function getDocumentDraftsControllerMessageUrl(threadId: DocumentDraftsControllerMessagePathParams["threadId"]) {
  const res = { method: 'POST', url: `/api/v1/document-drafts/${threadId}/messages` as const }  
  return res
}

/**
 * {@link /api/v1/document-drafts/:threadId/messages}
 */
export async function documentDraftsControllerMessage(threadId: DocumentDraftsControllerMessagePathParams["threadId"], data?: DocumentDraftsControllerMessageMutationRequest, config: Partial<RequestConfig<DocumentDraftsControllerMessageMutationRequest>> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const requestData = data  
  
  const res = await request<DocumentDraftsControllerMessageMutationResponse, ResponseErrorConfig<DocumentDraftsControllerMessage400 | DocumentDraftsControllerMessage401 | DocumentDraftsControllerMessage403>, DocumentDraftsControllerMessageMutationRequest>({ method : "POST", url : getDocumentDraftsControllerMessageUrl(threadId).url.toString(), data : requestData, ... requestConfig, headers : { 'Content-Type': 'application/vnd.api+json', ...requestConfig.headers } })  
  return res.data
}